import { toRaw } from 'vue'
import { Store } from 'vuex'

import { prefetchSmrStayDocuments } from '@/misc/stayDocuments'
import { refreshDisplayedSmrStay } from '@/misc/stayDocumentsMerge'
import { prefetchSmrStayJustifications } from '@/misc/stayJustifications'
import { prefetchSmrStaySuggestions } from '@/misc/staySuggestions'
import { RhsLoadingErrorReason, SmrLoadingErrorReason } from '@/store/modules/stay/smr/types'
import { RootState } from '@/store/types'

export async function refreshStay(stayId: string, idType: string, store: Store<RootState>) {
  await store.dispatch('smrStay/fetchStay', { idType, stayId })
  const request = store.state.smrStay.requests.fetchStay
  if (request.error) {
    throw new Error(request.error.status === 404 ? SmrLoadingErrorReason.SMR_STAY_NOT_FOUND : SmrLoadingErrorReason.SMR_STAY_OTHER)
  }
}

export async function refreshStayContent(
  store: Store<RootState>,
  documentsPromise: ReturnType<typeof prefetchSmrStayDocuments>,
  justificationsPromise: ReturnType<typeof prefetchSmrStayJustifications>,
  suggestionsPromise: ReturnType<typeof prefetchSmrStaySuggestions>
) {
  if (store.state.smrStay.rawStay) {
    const rawStay = toRaw(store.state.smrStay.rawStay)
    await refreshDisplayedSmrStay(rawStay, store.commit, store.state.stayList.currentSearch, store.state.settings.appSettings, null, documentsPromise, justificationsPromise, suggestionsPromise)
  }
}

export async function refreshRhs(rhsId: number, store: Store<RootState>) {
  await store.dispatch('smrStay/fetchRhs', rhsId)
  const request = store.state.smrStay.requests.fetchRhs
  if (request.error) {
    throw new Error(request.error.status === 404 ? RhsLoadingErrorReason.RHS_NOT_FOUND : RhsLoadingErrorReason.RHS_OTHER)
  }
}
